module.exports = "//static.hsappstatic.net/conversations-embed/static-1.24605/sass/messagesWidgetShell.sass"